import { createFileRoute } from "@tanstack/react-router";
import { ActiveScopesCard } from "@/components/active-scopes-card";
import { DashboardHero } from "@/components/dashboard-hero";
import { OrganizationInvitesCard } from "@/components/organization-invites-card";
import { SectionCards } from "@/components/section-cards";
import { SitesSummaryCard } from "@/components/sites-summary-card";
import { UpNextCard } from "@/components/up-next-card";
import { useAuth } from "@/hooks/use-auth";

function getGreeting(date = new Date()) {
  const hour = date.getHours();
  if (hour < 12) return "Good morning";
  if (hour < 18) return "Good afternoon";
  return "Good evening";
}

function DashboardHome() {
  const { user } = useAuth();
  const firstName = user?.name?.split(" ")[0];
  const greeting = `${getGreeting()}${firstName ? `, ${firstName}` : ""}.`;

  return (
    <div className="@container/main flex flex-1 flex-col">
      <div className="flex w-full flex-col gap-6 p-4 lg:p-7">
        {/* The overview spans every asset the user can see, so its masthead
            carries the product rather than the selected site. */}
        <DashboardHero tagline={greeting} />
        <SectionCards />
        <div className="grid grid-cols-1 gap-4 @4xl/main:grid-cols-[3fr_2fr]">
          <ActiveScopesCard />
          <UpNextCard />
        </div>
        <div className="space-y-4">
          <OrganizationInvitesCard />
          <SitesSummaryCard />
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/dashboard/")({
  component: DashboardHome,
  staticData: {
    title: "Overview",
  },
});
